import React, { useState } from 'react';
import Module from "../common/moduleTitle";
import Schedule from "../common/schedule";
import fh from "../../../images/aiReport/fh.png";

const ResultApp = (props) => {
    const { abilityList = [], } = props.data;

    if(abilityList && abilityList.length > 0){
        return (
            <div className="competency-wrap">
                <div className="readingTitleWrap">
                    <div className="readingTitleLeft">
                        <div className="readingTitleLeftIcon">
                            <span></span>
                            <span></span>
                        </div>
                        <span>胜任力分析</span>
                        {/*<div className="readingTitleTab active">*/}
                            {/*<i></i>*/}
                            {/*<p>匹配区间</p>*/}
                        {/*</div>*/}
                    </div>
                    <div className="readingTitleRight">

                    </div>
                </div>
                {/*内容部分*/}
                {
                    (
                        abilityList.map((item,key) => {
                            return (
                                <div className="result-padding" key={`ability${key}`}>
                                    <Module
                                        text={item.abilityItem || ''}
                                        enText="COMPETENCY"
                                    />
                                    <Schedule
                                        active={item.finalScore || 0}
                                        rangeMin={item.rangeMin || 0}
                                        rangeMax={item.rangeMax || 0}
                                    />
                                    {item.abilityAnalysis && <div className="result-evaluate" style={{marginTop: 24}}>
                                        <img src={fh} className="result-evaluate-d"/>
                                        {/* <div className="result-evaluate-tit">能力分析</div> */}
                                        <div className="result-evaluate-cont">{item.abilityAnalysis}</div>
                                    </div>}
                                </div>
                            )
                        })
                    )
                }

            </div>
        );
    } else {
        return null;
    }
}

export default ResultApp;
